import { type FC, useCallback } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { useNavigation } from '@/hooks/navigation';
import type { CookieGeoCountry } from './helpers';
import { ScLink } from './styles';

interface ICookieGeoTextProps {
  country: CookieGeoCountry;
}

export const CookieGeoText: FC<ICookieGeoTextProps> = ({ country }) => {
  const { t } = useTranslation('common');
  const { navigate } = useNavigation();

  const handleCookiePolicyRedirect = useCallback(() => {
    navigate('/cookie-policy');
  }, [navigate]);

  return (
    <>
      <div>
        <Trans
          components={{ 1: <ScLink onClick={handleCookiePolicyRedirect} /> }}
          i18nKey="common:modals.cookieGeo.title"
        />
      </div>
      <div>{t(`modals.cookieGeo.${country}`)}</div>
    </>
  );
};
